import thunkMiddleware from 'redux-thunk';
import rootReducer, { MainState } from './reducers';
import Productionize from '../misc/production-middleware';

export default function configureStore(initialState: MainState) {
    let createStoreWithMiddleware = Productionize([thunkMiddleware]);

    var store = createStoreWithMiddleware(
        rootReducer,
        initialState
    );

    return store;
}
